<template>
  <div v-show="isAtLeastOneNonVolumeByPriceOverlayPresent">
    <label
      :for="`style-menu-${id}`"
      class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
      v-if="shouldShowLabel"
    >STYLE</label>
    <br v-if="shouldShowLabel" />
    <select
      :class="{ 'hidden': !shouldDisplayStyleSelectMenu }"
      class="sc3-select-menu sc3-select-menu-inline sc3-select-menu-compact sc3-select-menu-white-and-grey sc3-select-menu-no-margins"
      :id="`style-menu-${id}`"
      :value="style"
      @change="styleMenuChanged($event)"
    >
      <option
        v-for="overlayStyleOption in OVERLAY_STYLES_ARRAY"
        :key="overlayStyleOption.title"
        :value="overlayStyleOption.title"
      >{{ overlayStyleOption.title }}</option>
    </select>
  </div>
</template>

<script lang="ts" setup>
  import { toRefs, computed } from 'vue';
  import { OVERLAY_STYLES_ARRAY } from '@/enums/overlay-styles';
  import { NONE, VOLUME_BY_PRICE } from '@/enums/indicators-and-overlays';

  const props = defineProps<{
    style: string;
    id: number;
    shouldShowLabel: boolean;
    isAtLeastOneNonVolumeByPriceOverlayPresent: boolean;
    overlayName: string;
  }>();
  const {
    style,
    id,
    shouldShowLabel,
    isAtLeastOneNonVolumeByPriceOverlayPresent,
    overlayName
  } = toRefs(props);

  const emit = defineEmits<{
    (e: 'update:style', style: string): void;
    (e: 'styleChanged'): void;
  }>();

  const shouldDisplayStyleSelectMenu = computed(() => {
    return !!overlayName.value && ![NONE, VOLUME_BY_PRICE.name].includes(overlayName.value);
  });

  function styleMenuChanged(e: Event) {
    if (!(e.target instanceof HTMLSelectElement)) {
      return;
    }

    emit('update:style', e.target.value);
    emit('styleChanged');
  }
</script>

<style scoped>
  .hidden {
    visibility: hidden;
  }
</style>
